module.exports = __webpack_public_path__ + "assets/400_500_visual-fa98fc.svg";